import { gql } from "graphql-tag";

export const NewTransactionSubscriptionGQL = gql`
  subscription newSubscriptionTransaction {
    newSubscriptionTransaction {
      amount
      type
    }
  }
`;
